import type { GraphResult } from "@mind/contracts/browser";

export type ExampleGraphLabels = {
  readonly project: string;
  readonly task: string;
  readonly document: string;
  readonly focusThread: string;
  readonly account: string;
};

const EXAMPLE_IDS = {
  project: "00000000-0000-7000-8000-000000000001",
  task: "00000000-0000-7000-8000-000000000002",
  document: "00000000-0000-7000-8000-000000000003",
  focusThread: "00000000-0000-7000-8000-000000000004",
  account: "00000000-0000-7000-8000-000000000005",
  projectTask: "00000000-0000-7000-8000-000000000101",
  taskDocument: "00000000-0000-7000-8000-000000000102",
  taskFocus: "00000000-0000-7000-8000-000000000103",
  taskAccount: "00000000-0000-7000-8000-000000000104",
} as const;

export function createExampleGraph(workspaceId: string, labels: ExampleGraphLabels): GraphResult {
  const project = {
    type: "project" as const,
    id: EXAMPLE_IDS.project,
    revision: "1",
  };
  const task = {
    type: "task" as const,
    id: EXAMPLE_IDS.task,
    revision: "1",
  };
  const document = {
    type: "document" as const,
    id: EXAMPLE_IDS.document,
    revision: "1",
  };
  const focusThread = {
    type: "focus_thread" as const,
    id: EXAMPLE_IDS.focusThread,
    revision: "1",
  };
  const account = {
    type: "account" as const,
    id: EXAMPLE_IDS.account,
    revision: "1",
  };
  return {
    nodes: [
      { ...project, workspaceId, label: labels.project, archived: false, tags: ["example"], projectId: null, ownerAccountId: EXAMPLE_IDS.account },
      { ...task, workspaceId, label: labels.task, archived: false, tags: ["example"], projectId: EXAMPLE_IDS.project, ownerAccountId: EXAMPLE_IDS.account },
      { ...document, workspaceId, label: labels.document, archived: false, tags: ["example"], projectId: EXAMPLE_IDS.project, ownerAccountId: EXAMPLE_IDS.account },
      { ...focusThread, workspaceId, label: labels.focusThread, archived: false, tags: ["example"], projectId: EXAMPLE_IDS.project, ownerAccountId: EXAMPLE_IDS.account },
      { ...account, workspaceId, label: labels.account, archived: false, tags: ["example"], projectId: null, ownerAccountId: EXAMPLE_IDS.account },
    ],
    edges: [
      { id: EXAMPLE_IDS.projectTask, workspaceId, linkType: "references", source: project, target: task, sourceMessageId: null, revision: "1", removedAt: null },
      { id: EXAMPLE_IDS.taskDocument, workspaceId, linkType: "supports", source: task, target: document, sourceMessageId: null, revision: "1", removedAt: null },
      { id: EXAMPLE_IDS.taskFocus, workspaceId, linkType: "derived_from", source: task, target: focusThread, sourceMessageId: null, revision: "1", removedAt: null },
      { id: EXAMPLE_IDS.taskAccount, workspaceId, linkType: "assigned_to", source: task, target: account, sourceMessageId: null, revision: "1", removedAt: null },
    ],
    loadedCount: 5,
    availableCount: 5,
    truncated: false,
    nextPageCursor: null,
  };
}
